// React imports
import * as React from 'react';

// Unspoken core imports
import ExerciseType from 'unspoken-core/lib/enums/ExerciseType';
import AttractionExercise from "unspoken-core/lib/models/AttractionExercise";
import Project from 'unspoken-core/lib/models/Project';
import Respondent from 'unspoken-core/lib/models/Respondent';

// Local imports
import withExerciseData from '../hoc/withExerciseData';
import AttractionExerciseContainer from './AttractionExerciseContainer';
import Error from './Error';

// Interface describing the props this component receives
interface ExerciseContainerProps {
  device: 'mobile' | 'desktop';
  exercise: AttractionExercise;
  skipTraining: boolean;
  respondent: Respondent;
  project: Project;  
}

/**
 * This generic exercise container receives the exercise 
 * data and URL parameters and renders the appropriate 
 * exercise container based on the exercise type
 */
class ExerciseContainer extends React.Component<ExerciseContainerProps> {
  
  public render () {

    if (this.props.exercise.type === ExerciseType.ATTRACTION) {
      return (
        <AttractionExerciseContainer 
          exercise={ this.props.exercise }
          skipTraining={ this.props.skipTraining }
          device={ this.props.device }
          respondent={ this.props.respondent }
          project={ this.props.project }
        />
      );
    }

    return <Error />;
  }

}

export default withExerciseData(ExerciseContainer);



// WEBPACK FOOTER //
// ./src/components/ExerciseContainer.tsx